import { QueryClient } from "@tanstack/react-query";

import { minutesTOms } from "@/lib/utils";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: minutesTOms(2), // 2 minutes default (reduced refetch frequency)
      gcTime: minutesTOms(5), // 5 minutes garbage collection
      retry: 2,
      refetchOnWindowFocus: false, // Disabled - only refetch on explicit user action or new data events
      refetchOnReconnect: false, // Disabled - rely on staleTime instead
      refetchOnMount: false, // Still refetch on mount to ensure fresh data when navigating
    },
    mutations: {
      retry: 1,
    },
  },
});
